module.exports = __webpack_public_path__ + "img/wolf_bg.745a3214.jpg";